<template>
  <div>
    <transition name="modal">
      <confirmation-modal
        v-if="showConfirmationModal"
        :message="'¿Estás seguro que deseas cambiar este descuento?'"
        @close="showConfirmationModal = false"
        @confirm="updateDiscount"
      ></confirmation-modal>
    </transition>

    <div>
      <div v-if="!showDiscountForm" class="flex items-center space-x-2">
        <div class="">
          {{
            paymentFrequency.discount_percentage
              ? paymentFrequency.discount_percentage + "%"
              : "0%"
          }}
        </div>

        <button
          class="secondary-button"
          @click.prevent="showDiscountForm = true"
        >
          Cambiar
        </button>
      </div>

      <div v-else class="flex items-center space-x-2">
        <input
          id="discount"
          type="number"
          v-model="discountAmount"
          class="w-20"
        />

        <button class="cancel-button" @click.prevent="showDiscountForm = false">
          Cancelar
        </button>

        <primary-button
          class=""
          :loading="loadingDiscountUpdate"
          type="submit"
          @click.prevent="showConfirmationModal = true"
          >Guardar</primary-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmationModal from "../ui/ConfirmationModal";
import api from "../../api";
export default {
  name: "Discount",

  components: {
    ConfirmationModal,
  },

  data() {
    return {
      showDiscountForm: false,
      discountAmount: null,
      showConfirmationModal: false,
      loadingDiscountUpdate: false,
    };
  },

  props: {
    paymentFrequency: Object,
  },

  created() {
    this.discountAmount = this.paymentFrequency.discount_percentage
      ? this.paymentFrequency.discount_percentage
      : 0;
  },

  methods: {
    async updateDiscount() {
      this.showConfirmationModal = false;
      this.loadingDiscountUpdate = true;

      try {
        const response = await api.plans.updatePaymentDiscount(
          this.paymentFrequency.id,
          {
            discount: this.discountAmount,
          }
        );
        this.$store.dispatch("successSnack", response.message);
        this.$emit("discountUpdated");
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingDiscountUpdate = false;
    },
  },
};
</script>